<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M15.4166 4.58341L12.3882 7.61184M7.60737 12.3927L4.58329 15.4167M4.58329 4.58341L7.60737 7.6075M12.3882 12.3883L15.4166 15.4167M17.7083 10.0001C17.7083 14.2573 14.2572 17.7084 9.99996 17.7084C5.74276 17.7084 2.29163 14.2573 2.29163 10.0001C2.29163 5.74289 5.74276 2.29175 9.99996 2.29175C14.2572 2.29175 17.7083 5.74289 17.7083 10.0001ZM13.5416 10.0001C13.5416 11.9561 11.956 13.5417 9.99996 13.5417C8.04395 13.5417 6.45829 11.9561 6.45829 10.0001C6.45829 8.04407 8.04395 6.45841 9.99996 6.45841C11.956 6.45841 13.5416 8.04407 13.5416 10.0001Z" 
    stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

<script>
export default {
  name: 'ContactSupportIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
    }
  }
}
</script>

<style scoped></style>